export enum PurchaseCategory {
	StandardGoodAndServices = "Standard Good and Services",
	ProfessionalAndSpecialisedServices = "Professional and Specialised Services",
	TravelAndTravelRelatedServices = "Travel and Travel Related Services",
	CAPEXPurchases = "CAPEX Purchases",
	CAPEXSupport = "CAPEX Support Services",
	Revenue = "Revenue",
}

export enum PurchaseCategoryId {
	StandardGoodAndServices = 1,
	ProfessionalAndSpecialisedServices = 2,
	TravelAndTravelRelatedServices = 3,
	CAPEXPurchases = 4,
	CAPEXSupport = 5,
	Revenue = 6,
}
